import {Modal, Table, Tag, Empty} from "antd";
import {FontAwesomeIcon, Loading} from "~/components";
import {useGetRankSerpQuery} from "~/reduxs/api/rankApiSlice";

/** Nhãn tiếng Việt cho SERP features. */
const FEATURE_LABELS = {
	featured_snippet: 'Đoạn trích nổi bật',
	people_also_ask: 'Mọi người cũng hỏi',
	local_pack: 'Bản đồ / địa phương',
	knowledge_graph: 'Bảng tri thức',
	related_searches: 'Tìm kiếm liên quan',
	video: 'Video',
	images: 'Hình ảnh',
	top_stories: 'Tin hàng đầu',
	shopping: 'Mua sắm',
	ai_overview: 'AI Overview',
};

/**
 * Modal xem trang SERP mới nhất của 1 từ khoá theo dõi: top organic (đánh dấu domain dự án),
 * SERP features, số kết quả. Đối thủ = mọi domain khác trong danh sách (từ cùng snapshot, 0đ).
 */
function RankSerpModal({open, onClose, projectId, tracked}) {

	const {data, isFetching} = useGetRankSerpQuery(
		{projectId, trackedId: tracked?.id},
		{skip: !open || !tracked},
	);

	const columns = [
		{title: '#', dataIndex: 'rank', key: 'rank', width: 56, align: 'center',
			render: (v, r) => <Tag color={r.is_own ? 'gold' : 'default'} style={{marginInlineEnd: 0}}>{v}</Tag>},
		{title: 'Domain', dataIndex: 'domain', key: 'domain', width: 200, ellipsis: true,
			render: (v, r) => r.is_own ? <strong style={{color: '#ca8a04'}}>{v} <FontAwesomeIcon icon="fa-solid fa-star" /></strong> : v},
		{title: 'Tiêu đề', dataIndex: 'title', key: 'title', ellipsis: true,
			render: (v, r) => <a href={r.url} target="_blank" rel="noreferrer">{v || r.url}</a>},
	];

	return (
		<Modal open={open} onCancel={onClose} footer={null} width={780}
			title={tracked ? `SERP: "${tracked.keyword}"` : 'SERP'}>
			{isFetching ? <Loading /> : !data?.has_snapshot ? (
				<Empty description="Chưa có dữ liệu SERP cho từ khoá này. Bấm 'Kiểm tra ngay' rồi chờ ít phút." />
			) : (
				<div>
					<div style={{marginBottom: 12, display: 'flex', gap: 16, flexWrap: 'wrap', fontSize: 13, color: '#6b7280'}}>
						<span><FontAwesomeIcon icon="fa-light fa-desktop" /> {data.device === 'mobile' ? 'Mobile' : 'Desktop'}</span>
						<span><FontAwesomeIcon icon="fa-light fa-earth-asia" /> {data.location}</span>
						<span><FontAwesomeIcon icon="fa-light fa-calendar" /> {data.checked_date}</span>
						{data.results_count > 0 && <span>~{Number(data.results_count).toLocaleString('vi-VN')} kết quả</span>}
					</div>

					{data.features?.length > 0 && (
						<div style={{marginBottom: 12}}>
							<span style={{fontSize: 13, color: '#6b7280', marginRight: 8}}>SERP features:</span>
							{data.features.map((f) => (
								<Tag key={f} color="geekblue">{FEATURE_LABELS[f] || f}</Tag>
							))}
						</div>
					)}

					<Table
						rowKey={(r) => `${r.rank}-${r.domain}`}
						size="small"
						columns={columns}
						dataSource={data.results || []}
						scroll={{x: 'max-content', y: 420}}
						pagination={false}
					/>
				</div>
			)}
		</Modal>
	);
}

export default RankSerpModal;
